import { Component, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { UsersService } from 'src/app/data/services/users.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LessonsService } from 'src/app/data/services/lessons.service';
import { MatDialog } from '@angular/material/dialog';
import { BugReportDialogComponent } from 'src/app/shared/components/bug-report-dialog/bug-report-dialog.component';
import { RoleService } from 'src/app/core/auth/services/role.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @ViewChild('pendingChangesDialogTemplate') pendingChangesDialogTemplate!: TemplateRef<any>;

  public profiles: { id: number; name: string, group: string }[] = [];
  public selectedOrganizationId!: string;
  public currentUserGroup: string = "";

  constructor(
    public authService: AuthService,
    public userService: UsersService,
    public router: Router,
    private storage: StorageService,
    private location: Location,
    private lessonsService: LessonsService,
    public dialog: MatDialog,
    private roleService: RoleService
  ) { 
    
    this.userService.user$.pipe(take(1)).subscribe(user => {
      if (user) {
        this.currentUserGroup = user.group;
        user.organizations?.forEach((elem) => {
          this.profiles.push({ id: elem.id, name: elem.name, group: elem.group });
          this.selectedOrganizationId = this.storage.get('selectedOrganization') || this.profiles[0].id.toString();
        });
      }
    });
  }

  getFullName(): string {
    const userData = this.userService.getUserData();
    if(!userData) return '';
    const firstname = userData?.firstname ?? '';
    const lastname = userData?.lastname ?? '';
    return `${firstname} ${lastname}`.trim();
  }

  getProfileImg(): string {
    const userData = this.userService.getUserData();
    return userData?.profileImg || 'assets/levelablogo.png';
  }

  logout(): void {
    if (
      this.router.url.includes('/lesson/') &&
      this.router.url.includes('/edit') &&
      this.lessonsService.isModified()
    ){
      this.openPendingChangesDialog();
    }else{
      this.authService.logout();
    }
  }

  navigateToPreviousPage(): void {
    this.location.back();
  }

  navigateToHome(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }
  
    event.preventDefault();
  
    if (this.router.url === '/' || this.router.url === '/dashboard') {
      window.location.reload();
    } else {
      this.router.navigateByUrl('/');
    }
  }

  onOrganizationChange(): void {
    this.storage.set("selectedOrganization", this.selectedOrganizationId);

    this.userService.loadUser().pipe(take(1)).subscribe(user => {
      if (!user) {
        this.router.navigateByUrl('/login');
        return;
      }

      const destination = this.roleService.getHomeRouteForGroup((user as any).group);
      window.location.href = destination;
    });
  }

  openPendingChangesDialog() {
    const dialogRef = this.dialog.open(this.pendingChangesDialogTemplate, {
      data: {
        primaryObservable: new Observable(observer => {
          this.lessonsService.logoutWithoutSaving = true;
          this.authService.logout();
          observer.next();
          observer.complete();
        }),
        secondaryObservable: new Observable(observer => {
          observer.next();
          observer.complete();
        }),
      }
    });

    return dialogRef.afterClosed().pipe(
      map(result => {
        if (result == undefined ) {
          return false;
        } else {
          return true;
        }
      })
    )
  }

  openBugReportDialog(): void {
    this.dialog.open(BugReportDialogComponent, {
      data: { request: {
        body: {}
      } },
      maxHeight: '100%',
      width: '540px',
      maxWidth: '100%',
      disableClose: false,
      hasBackdrop: true,
    });
  }
}